module.exports = __webpack_public_path__ + "img/L_323_325.a9f890b9.png";